/* eslint-disable import/prefer-default-export */
import { api } from './client';

export const httpCreateActivity = (payload) => api().post('api/activities', payload);
